// extracted by mini-css-extract-plugin
module.exports = {"button":"index__button___1EiTW"};